import { combineReducers } from "@reduxjs/toolkit";
import sessionsReducer from "./reducers/sessionsReducer";
import myPermitsReducer from "./reducers/uiReducers/myPermitsReducer";

import userSessionReducer from "./reducers/userSessionReducer";
import subUserSessionReducer from "./reducers/subUserSessionReducer";
import guestSessionReducer from "./reducers/guestSessionReducer";
import notarySessionReducer from "./reducers/notarySessionReducer";
import privateProviderSessionReducer from "./reducers/privateProviderSessionReducer";

import nocDataReducer from "./reducers/nocDataReducer";
import notificationsReducer from "./reducers/notificationsReducer";
import userPackagesReducer from "./reducers/userPackagesReducer";
import buildingStateReducer from "./reducers/permitFormReducers/buildingStateReducer";
import paisStateReducer from "./reducers/permitFormReducers/paisStateReducer";
import nocStateReducer from "./reducers/permitFormReducers/nocStateReducer";
import modalControlStateReducer from "./reducers/permitFormReducers/modalControlStateReducer";

export const createDynamicReducer = (sessionType) => {
  const dynamicReducers = {
    sessions: sessionsReducer, // always include the sessions reducer
    myPermitsComponent: myPermitsReducer,
    buildingState: buildingStateReducer,
    paisState: paisStateReducer,
    nocState: nocStateReducer,
    modalControlState: modalControlStateReducer,
  };

  // Add reducers based on session type
  if (sessionType === "userSession") {
    dynamicReducers.userSession = userSessionReducer;
  } else if (sessionType === "subUserSession") {
    dynamicReducers.subUserSession = subUserSessionReducer;
  } else if (sessionType === "notarySession") {
    dynamicReducers.notarySession = notarySessionReducer;
  } else if (sessionType === "guestSession") {
    dynamicReducers.guestSession = guestSessionReducer;
  } else if (sessionType === "privateProviderSession") {
    dynamicReducers.privateProviderSession = privateProviderSessionReducer;
  }

  // Additional static reducers can be added here if needed
  dynamicReducers.nocData = nocDataReducer;
  dynamicReducers.notifications = notificationsReducer;
  dynamicReducers.userPackages = userPackagesReducer;

  return combineReducers(dynamicReducers);
};
